<template>
  <div id="app">
    <router-view />
    <axios-res></axios-res>
  </div>
</template>

<script>
import "./assets/css/iconfont.css";
import axios from "axios"
export default {
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      
    }
  },
  methods: {
    watchWindowSize() {
      if (!window.screenTop && !window.screenY) {
        //非全屏
        this.$store.state.isFullScreen = false;
      }else{
        //全屏
        this.$store.state.isFullScreen = true;
      }

      // 可视区域的高度
      //const clientHeight = document.documentElement.clientHeight || document.body.clientHeight
      //screen是window的属性方法，window.screen可省略window，指的是窗口
      //this.isFullScreen = screen.height == clientHeight
    },
  },
  mounted() {
    window.addEventListener("resize", this.watchWindowSize);
    
  },
};
</script>





// WEBPACK FOOTER //
// src/App.vue